(
    function (skyward, $, undefined)
    {
        skyward.grading = skyward.grading || {};

        var init = function (selector)
        {
            $(selector).find('.childrecordquickentryaddviewpart.honorrollmethodisactivecheckbox').click(function ()
            {
                skyward.grading.honorRollMethodDefaultValueFunction($(this));
            });

            $(selector).find('[id^="editGradeBucketFlagDetails_UseEarnedOverride-"]').off('click', skyward.grading.UseEarnedOverrideSetReadOnly).on('click', skyward.grading.UseEarnedOverrideSetReadOnly);
            $(selector).find('[id^="editGradeBucketFlagDetails_UseEarnedOverride-"]').each(skyward.grading.UseEarnedOverrideSetReadOnly);
            $(selector).find('#StudentGradeBucketsDOV_btnStudentGradeBucketStatusLegend').off('click', displayStudentGradeBucketStatusLegend).on('click', displayStudentGradeBucketStatusLegend);

            var retainOnChange = function ()
            {
                skyward.grading.retainChanged($(this));
            };
            var retainCheckbox = $(selector).find('.retainCheckBox');
            retainCheckbox.on('change', retainOnChange);
            var retainValue = skyward.controls.getValue(retainCheckbox);
            if (!retainValue)
            {
                $(selector).find('.retainTextBox').attr('readonly', 'readonly');
            }

            $(selector).find('.CourseGPAMethodGradeReferenceOverrideUseOverride').each(function () {
                var useOverrideCheckbox = $(this);
                var checkboxID = useOverrideCheckbox.attr('id').split('-')[1];
                useOverrideCheckbox.off('click', function () { skyward.grading.setCourseGPAMethodGradeReferenceOverride(useOverrideCheckbox, checkboxID); }).on('click', function () { skyward.grading.setCourseGPAMethodGradeReferenceOverride(useOverrideCheckbox, checkboxID); });
            });

            $(selector).find('.CourseEarnedCreditsMethodGradeReferenceOverrideUseOverride').each(function () {
                var useOverrideCheckbox = $(this);
                var checkboxID = useOverrideCheckbox.attr('id').split('-')[1];
                useOverrideCheckbox.off('click', function () { skyward.grading.setCourseEarnedCreditsMethodGradeReferenceOverride(useOverrideCheckbox, checkboxID); }).on('click', function () { skyward.grading.setCourseEarnedCreditsMethodGradeReferenceOverride(useOverrideCheckbox, checkboxID); });
            });

            $(selector).find('.js-GradeBucketFlagDetailGPAMethodUseOverride').each(function ()
            {
                var useOverrideCheckbox = $(this);
                var checkboxID = useOverrideCheckbox.attr('id').split('-')[1];
                useOverrideCheckbox.off('click', function () { skyward.grading.setGradeBucketFlagDetailGPAMethodUseOverride(useOverrideCheckbox, checkboxID); }).on('click', function () { skyward.grading.setGradeBucketFlagDetailGPAMethodUseOverride(useOverrideCheckbox, checkboxID); });
            });

            $(selector).find('#editCourseGPAMethod_UseOverride').off('click', function () { skyward.grading.courseoverridevaluefunction('editCourseGPAMethod_GPACredit', 'editCourseGPAMethod_UseOverride'); }).on('click', function () { skyward.grading.coursegpamethodvaluefunction('editCourseGPAMethod_GPACredit', 'editCourseGPAMethod_UseOverride'); });

            if ($(selector).find("#RankUtility_SelectFiltersTask").length)
            {
                $(selector).find("input[name = 'RunOptionchild']").on("change", function () { rankSetGPACalculationMethodForNewRun(this); });
            }

            if ($(selector).find("#HonorRollUtility_SelectFiltersTask").length)
            {
                $(selector).find("input[name = 'RunOptionchild']").on("change", function () { honorRollSetGPACalculationMethodForNewRun(this); });
                $(selector).find("textarea[id = 'HonorRollRunLevelParameterDescriptions']").attr('readonly', 'readonly');
            }

            $(selector).find("select.honorRollInclusionTypeClassname").on("change", function ()
            {
                honorRollSetDependentVisibility(this);
            });

            if ($(selector).find("select.honorRollInclusionTypeClassname").length)
            {
                honorRollSetDependentVisibility($(selector).find("select.honorRollInclusionTypeClassname"));
            }

            if ($(selector).find("#SelectedGradesUtilityDiv").length)
            {
                var selectedGradesParent = $(selector).find("#SelectedGradesUtilityDiv");
                SelectedGradesSetDependencies(selectedGradesParent);
                $(selector).find('.SelectedGradesDependentParent').on('change', function ()
                {
                    SelectedGradesSetDependencies(selectedGradesParent);
                });
            }

            if ($(selector).find("#GradeReportTemplateTestTypeWorkflowDiv").length)
            {
                $(selector).find(".gradeReportTemplateTestTypeSelect").on("change", function ()
                {
                    GradeReportTemplateTestTypeChange($(this).parents('#GradeReportTemplateTestTypeWorkflowDiv'), true);
                });

                $(selector).find(".gradeReportTemplateTestVersionSelect").on("change", function ()
                {
                    GradeReportTemplateTestTypeChange($(this).parents('#GradeReportTemplateTestTypeWorkflowDiv'), true);
                });
            }
            if ($(selector).find("#editGradeReportTemplateTestType_GradeReportTemplateTestTypeDetailsDiv").length)
            {
                $(selector).find(".gradeReportTemplateTestTypeSelect").on("change", function ()
                {
                    GradeReportTemplateTestTypeChange($(this).parents('#editGradeReportTemplateTestType_GradeReportTemplateTestTypeDetailsDiv'));
                });

                $(selector).find(".gradeReportTemplateTestVersionSelect").on("change", function ()
                {
                    GradeReportTemplateTestTypeChange($(this).parents('#editGradeReportTemplateTestType_GradeReportTemplateTestTypeDetailsDiv'));
                });
            }

            //Add Out of District Transfer Course
            $(selector).find('.transferCourseUpdatesGradeMarkInformation').parent().on('codeEELValuesUpdated', updateTransferCourseGradeMarkData);
            $(selector).find('.transferCourseUpdateCompetionDate').on('change', updateTransferCourseCompletionDate);
            $(selector).find('.TransferCourseGradeBucketFlag').parent().on('change', updateTransferCourseGradeBucketFlagData);
            $(selector).find('#TransferCourseCreditOverride').on('change', resetTransferCourseCreditOverride);
            $(selector).find('#PointSetAndCreditOverride').on('change', resetTransferCourseGPACreditOverride);
            $(selector).find('#CourseEarnedPercentOverride').on('change', resetTransferCoursePercentOverride);
            $(selector).find('#CourseGPAPercentOverride').on('change', resetTransferCourseGPAPercentOverride);
            $(selector).find('#TransferCourseEarnedCreditsTextBox').on('change', updateEarnedCreditPopupCalculation);
            $(selector).find('.TransferCourseEarnedPercentOverrideBox').on('change', updateEarnedCreditPopupCalculation);
            $(selector).find('#TransferCourseGPAPopupPossibleCreditBox').on('change', updateGPACreditPopupCalculation);
            $(selector).find('#TransferCourseGPAPopupPointSetID').on('change', updateGPACreditPopupCalculation);
            $(selector).find('.TransferCourseGPAPercentOverrideBox').on('change', updateGPACreditPopupCalculation);
            $(selector).find('#ChangeSectionToOutOfDistrictTransferCourse').on('click', makeOutOfDistrictTransferCoursePopup);

            if ($(selector).find('.fileNameFormatContainer').length)
            {
                rebuildFileNameOutput($(selector).find('.fileNameFormatContainer'));
            };

            $(selector).find('.fileNameFormatContainer').on('childrecordquickentry-row-added', function (event, row)
            {
                var fileNameFormatContainer = row.parents(".fileNameFormatContainer").first();
                var fieldCount = skyward.controls.getValue(fileNameFormatContainer.find(".fileNameFormatFieldCount"));

                if (fieldCount != fileNameFormatContainer.find("tr.childrecordquickentryrow").length)
                {
                    return;
                }

                var backingDataField = fileNameFormatContainer.find(".fileNameFormatOutputBackingData");
                var backingDataJSONDerulo = backingDataField.length &&
                    backingDataField.val() != null &&
                    backingDataField.val() != ""
                    ? JSON.parse(backingDataField.val())
                    : {};
                var childRecordQuickEntry = fileNameFormatContainer.find(".fileNameFormatQuickEntry");

                $.each(backingDataJSONDerulo, function (k, v)
                {
                    var field = childRecordQuickEntry.find("#" + k);
                    if (field.length)
                    {
                        skyward.controls.setValue(field, v.optionValue)
                        if (v.customTextValue)
                        {
                            var customTextHelp = field.parents("tr").first().find(".customTextFieldset input.customText");
                            skyward.controls.setValue(customTextHelp, v.customTextValue);
                        }
                        if (v.dateValue)
                        {
                            var datepicker = field.parents("tr").first().find(".datePickerFieldset sky-datepicker");
                            var parts = v.dateValue.split("-");
                            if (parts.length == 3)
                            {
                                var d = new Date(parts[0], parts[1] - 1, parts[2]);
                                skyward.controls.setValue(datepicker, d);
                            }
                        }
                    }
                });

                //Once we have initialized it lets clear our initial backing data so it doesn't try and mess with anything
                skyward.controls.setValue(backingDataField, "");
            });

            $(selector).find('.fileNameFormatContainer').on('childrecordquickentry-row-cleared', '.childrecordquickentryclearbuttoncell', function (event, row, isRowBeingRemoved)
            {
                if (isRowBeingRemoved)
                {
                    row.addClass("skip");
                }
                rebuildFileNameOutput($(this).parents(".fileNameFormatContainer"));
            });
            $(selector).find('.fileNameFormatDelimiterType').on('change', function ()
            {
                var container = $(this).parents(".fileNameFormatContainer");
                rebuildFileNameOutput(container);
            });

            $(selector).find('.fileNameFormatContainer').on('change', '.fileNameFormatEntryOption', function ()
            {
                var select = $(this);
                var customTextHelp = select.parents("tr").first().find(".customTextFieldset");
                var datePickerFieldset = select.parents("tr").first().find(".datePickerFieldset");

                if (skyward.controls.getValue(select) == "CU")
                {
                    if (customTextHelp.hasClass("hidden"))
                    {
                        customTextHelp.removeClass("hidden");
                    }
                }
                else
                {
                    if (!customTextHelp.hasClass("hidden"))
                    {
                        customTextHelp.addClass("hidden");
                    }
                }

                if (skyward.controls.getValue(select) == "DA")
                {
                    if (datePickerFieldset.hasClass("hidden"))
                    {
                        datePickerFieldset.removeClass("hidden");
                    }

                    var datepicker = datePickerFieldset.find("sky-datepicker");
                    const datePickerValue = skyward.controls.getValue(datepicker);
                    if (!datePickerValue || !datePickerValue.isValidDate())
                    {
                        skyward.controls.setValue(datepicker, new Date())
                    }
                }
                else
                {
                    if (!datePickerFieldset.hasClass("hidden"))
                    {
                        datePickerFieldset.addClass("hidden");
                    }
                }

                rebuildFileNameOutput(select.parents(".fileNameFormatContainer"));
            });

            $(selector).find('.fileNameFormatContainer').on('change', '.customText, sky-datepicker', function ()
            {
                var select = $(this);
                rebuildFileNameOutput(select.parents(".fileNameFormatContainer"));
            });
        };

        var SelectedGradesSetDependencies = function (parentDiv)
        {
            var parentContainer = $(parentDiv);

            var courseSelection = parentContainer.find(".SelectedGradesDependentParent.CourseFilterOption");
            var entityCheckbox = parentContainer.find(".SelectedGradesDependentParent.AdditionalEntities");
            var cecsExists = skyward.controls.getValue(parentContainer.find("#CECSExistsValue"));
            var courseFilterCode = parentContainer.find("#fsCourseFilterCode");
            var specificCourses = parentContainer.find("#fsSpecificCourses");
            var additionalEntitiesCheckboxFieldset = parentContainer.find("#fsAdditionalEntities");
            var additionalEntitiesDiv = parentContainer.find("#divAdditionalEntities");

            var courseSelectionValue = skyward.controls.getValue(courseSelection);
            if (courseSelectionValue == "IC")
            {
                courseFilterCode.hide();
                specificCourses.show();
            }
            else
            {
                courseFilterCode.show();
                specificCourses.hide();
            }

            if (cecsExists == "True")
            {
                var entityCheckboxValue = skyward.controls.getValue(entityCheckbox);
                if (entityCheckboxValue)
                {
                    additionalEntitiesDiv.show();
                    var specificCoursesCECS = parentContainer.find("#fsSpecificCoursesCECS");
                    if (courseSelectionValue == "IC")
                    {
                        specificCoursesCECS.show();
                    }
                    else
                    {
                        specificCoursesCECS.hide();
                    }
                }
            }
            else
            {
                additionalEntitiesCheckboxFieldset.hide();
                additionalEntitiesDiv.hide();
            }
        }

        var GradeReportTemplateTestTypeChange = function (parentDiv, isWorkflow)
        {
            var parentContainer = $(parentDiv);
            var testTypeValue = skyward.controls.getValue(parentContainer.find(".gradeReportTemplateTestTypeSelect"));
            var testVersionValue = skyward.controls.getValue(parentContainer.find(".gradeReportTemplateTestVersionSelect"));

            var dataParams =
            {
                newTestTypeCode: testTypeValue,
                newTestVersionCode: testVersionValue
            };

            var urlString = "UpdateTestColumnViewPartsDetails";
            if (isWorkflow)
            {
                urlString = "UpdateTestColumnViewPartsWorkflow";
            }
            else
            {
                dataParams.gradeReportTemplateTestTypeID = skyward.controls.getValue(parentContainer.find("#editGradeReportTemplateTestType_GradeReportTemplateTestTypeIDInput"));
            }

            $.ajax
            ({
                url: skyward.global.virtualDir + "Grading/GradereportTemplateTestType/" + urlString,
                type: "POST",
                dataType: "JSON",
                data: dataParams,
                success: async function (parseData)
                {
                    var updateHTML = parseData.Success;
                    if (updateHTML === true)
                    {
                        await parentContainer.find('#TestColumnViewPartContainer').viewpartHtml(parseData.ViewPartHTML);
                        skyward.window.notifyResize();
                        skyward.window.notifyDOMLoad("#TestColumnViewPartContainer");
                    }
                }
            });
        };

        const initGradeReportHeaderFields = function ()
        {
            this.find('.GradeReportHeaderRow').each(function ()
            {
                GradeReportSetHeaderDependencies(this);
            });

            this.find('select.GradeReportFieldSelectComboBox').on('change', function ()
            {
                GradeReportSetHeaderDependencies($(this).parents('.GradeReportHeaderRow'));
            });
            this.find('select.GradeReportColumnCountComboBox').on('change', function ()
            {
                GradeReportSetHeaderDependencies($(this).parents('.GradeReportHeaderRow'));
            });
        };

        const initStudentSectionLinkFormat = function ()
        {
            const container = skyward.window.getClosestContentPanel(this);

            const formatBox = this;
            const radioButton = container.find(".js-studentsectionlinking__studentsectionlinkoptioncode");
            const courseType = container.find(".js-studentsectionlinking__usestudentsectionlinkcoursetype");
            const transcriptArea = container.find(".js-studentsectionlinking__usestudentsectionlinktranscriptarea");

            generateStudentSectionLinkFormatSample(formatBox, radioButton, courseType, transcriptArea);

            radioButton.add(courseType).add(transcriptArea)
                .on("change", function ()
                {
                    generateStudentSectionLinkFormatSample(formatBox, radioButton, courseType, transcriptArea);
                });
        };

        var GradeReportSetHeaderDependencies = function (rowDiv)
        {
            var rowContainer = $(rowDiv);
            const row = rowContainer.data("row");

            const columnCount = skyward.controls.getValue(rowContainer.find(`.GradeReportColumnCountComboBox[data-row="${row}"]`));
            const firstComboBoxValue = skyward.controls.getValue(rowContainer.find(".GradeReportFieldSelectComboBox[data-column=\"1\"]"));
            const secondComboBoxValue = skyward.controls.getValue(rowContainer.find(".GradeReportFieldSelectComboBox[data-column=\"2\"]"));

            const rankMethodRowContainer = rowContainer.siblings(`.GradeReportRankMethodRow[data-row="${row}"]`);
            var dummyRankMethodDiv = rankMethodRowContainer.children(".GradeReportRankMethodContainer[data-column=\"dummy\"]");
            var firstRankMethodContainer = rankMethodRowContainer.children(".GradeReportRankMethodContainer[data-column=\"1\"]");
            var secondRankMethodContainer = rankMethodRowContainer.children(".GradeReportRankMethodContainer[data-column=\"2\"]");

            var gPAMethodRowContainer = rowContainer.siblings(`.GradeReportGPAMethodRow[data-row="${row}"]`);
            var dummyGPAMethodDiv = gPAMethodRowContainer.children(".GradeReportGPAMethodContainer[data-column=\"dummy\"]");
            var firstGPAMethodContainer = gPAMethodRowContainer.children(".GradeReportGPAMethodContainer[data-column=\"1\"]");
            var secondGPAMethodContainer = gPAMethodRowContainer.children(".GradeReportGPAMethodContainer[data-column=\"2\"]");

            var gPABucketRowContainer = rowContainer.siblings(`.GradeReportGPABucketRow[data-row="${row}"]`);
            var dummyGPABucketDiv = gPABucketRowContainer.children(".GradeReportGPABucketContainer[data-column=\"dummy\"]");
            var firstGPABucketContainer = gPABucketRowContainer.find(".GradeReportGPABucketContainer[data-column=\"1\"]");
            var secondGPABucketContainer = gPABucketRowContainer.find(".GradeReportGPABucketContainer[data-column=\"2\"]");

            var firstGPABucketCodeelCode = gPABucketRowContainer.find(".GradeReportHeaderGPABucketCodeel[data-column=\"1\"]");
            var secondGPABucketCodeelCode = gPABucketRowContainer.find(".GradeReportHeaderGPABucketCodeel[data-column=\"2\"]");

            var honorRollCodeEELContainer = rowContainer.siblings(`.HonorRollRunRow[data-row="${row}"]`);
            var dummyHonorRollRunCodeelCode = honorRollCodeEELContainer.children(".HonorRollRunContainer[data-column=\"dummy\"]");
            var firstHonorRollCodeelCode = honorRollCodeEELContainer.find(".HonorRollRunContainer[data-column=\"1\"]");
            var secondHonorRollCodeelCode = honorRollCodeEELContainer.find(".HonorRollRunContainer[data-column=\"2\"]");

            function isGPAField(field) {
                var gPAFields = { GP:true, GF:true, GB:true }
                return gPAFields.hasOwnProperty(field);
            }

            function isRankField(field)
            {
                var rankFields = { RK: true, RN: true, RP: true }
                return rankFields.hasOwnProperty(field);
            }

            function isHonorRollField(field)
            {
                var honorRollFields = { HR: true }
                return honorRollFields.hasOwnProperty(field);
            }

            if (columnCount == 2)
            {
                // Rank
                if (isRankField(firstComboBoxValue) && isRankField(secondComboBoxValue))
                {
                    rankMethodRowContainer.show();
                    dummyRankMethodDiv.hide();
                    secondRankMethodContainer.show();
                    firstRankMethodContainer.show();
                }
                else if (isRankField(firstComboBoxValue) && !isRankField(secondComboBoxValue))
                {
                    rankMethodRowContainer.show();
                    dummyRankMethodDiv.hide();
                    secondRankMethodContainer.hide();
                    firstRankMethodContainer.show();
                }
                else if (!isRankField(firstComboBoxValue) && isRankField(secondComboBoxValue))
                {
                    rankMethodRowContainer.show();
                    dummyRankMethodDiv.show();
                    secondRankMethodContainer.show();
                    firstRankMethodContainer.hide();
                }
                else
                {
                    rankMethodRowContainer.hide();
                    dummyRankMethodDiv.hide();
                    secondRankMethodContainer.hide();
                    firstRankMethodContainer.hide();
                }

                //GPA
                if (isGPAField(firstComboBoxValue) && isGPAField(secondComboBoxValue))
                {
                    gPAMethodRowContainer.show();
                    dummyGPAMethodDiv.hide();
                    secondGPAMethodContainer.show();
                    firstGPAMethodContainer.show();

                    gPABucketRowContainer.show();
                    dummyGPABucketDiv.hide();
                    secondGPABucketContainer.show();
                    firstGPABucketContainer.show();
                }
                else if (isGPAField(firstComboBoxValue) && !isGPAField(secondComboBoxValue))
                {
                    gPAMethodRowContainer.show();
                    dummyGPAMethodDiv.hide();
                    secondGPAMethodContainer.hide();
                    firstGPAMethodContainer.show();

                    gPABucketRowContainer.show();
                    dummyGPABucketDiv.hide();
                    secondGPABucketContainer.hide();
                    firstGPABucketContainer.show();
                }
                else if (!isGPAField(firstComboBoxValue) && isGPAField(secondComboBoxValue))
                {
                    gPAMethodRowContainer.show();
                    dummyGPAMethodDiv.show();
                    secondGPAMethodContainer.show();
                    firstGPAMethodContainer.hide();

                    gPABucketRowContainer.show();
                    dummyGPABucketDiv.show();
                    secondGPABucketContainer.show();
                    firstGPABucketContainer.hide();
                }
                else
                {
                    gPAMethodRowContainer.hide();
                    dummyGPAMethodDiv.hide();
                    secondGPAMethodContainer.hide();
                    firstGPAMethodContainer.hide();

                    gPABucketRowContainer.hide();
                    dummyGPABucketDiv.hide();
                    secondGPABucketContainer.hide();
                    firstGPABucketContainer.hide();
                }

                //HonorRoll
                if (isHonorRollField(firstComboBoxValue) && isHonorRollField(secondComboBoxValue))
                {
                    honorRollCodeEELContainer.show();
                    dummyHonorRollRunCodeelCode.hide();
                    firstHonorRollCodeelCode.show();
                    secondHonorRollCodeelCode.show();
                }
                else if (isHonorRollField(firstComboBoxValue) && !isHonorRollField(secondComboBoxValue))
                {
                    honorRollCodeEELContainer.show();
                    dummyHonorRollRunCodeelCode.hide();
                    firstHonorRollCodeelCode.show();
                    secondHonorRollCodeelCode.hide();
                }
                else if (!isHonorRollField(firstComboBoxValue) && isHonorRollField(secondComboBoxValue))
                {
                    honorRollCodeEELContainer.show();
                    dummyHonorRollRunCodeelCode.show();
                    firstHonorRollCodeelCode.hide();
                    secondHonorRollCodeelCode.show();
                }
                else
                {
                    honorRollCodeEELContainer.hide();
                    dummyHonorRollRunCodeelCode.hide();
                    firstHonorRollCodeelCode.hide();
                    secondHonorRollCodeelCode.hide();
                }


            }
            else if (columnCount == 1)
            {
                dummyRankMethodDiv.hide();
                secondRankMethodContainer.hide();

                if (isRankField(firstComboBoxValue)) {
                    rankMethodRowContainer.show();
                    firstRankMethodContainer.show();
                }
                else
                {
                    rankMethodRowContainer.hide();
                }

                dummyGPAMethodDiv.hide();
                secondGPAMethodContainer.hide();

                dummyGPABucketDiv.hide();
                secondGPABucketContainer.hide();

                if (isGPAField(firstComboBoxValue))
                {
                    gPAMethodRowContainer.show();
                    firstGPAMethodContainer.show();

                    gPABucketRowContainer.show();
                    firstGPABucketContainer.show();
                }
                else
                {
                    gPAMethodRowContainer.hide();
                    gPABucketRowContainer.hide();
                }

                dummyRankMethodDiv.hide();
                secondHonorRollCodeelCode.hide();

                if (isHonorRollField(firstComboBoxValue))
                {
                    honorRollCodeEELContainer.show();
                    firstHonorRollCodeelCode.show();
                }
                else
                {
                    honorRollCodeEELContainer.hide();
                    firstHonorRollCodeelCode.hide();
                }
            }
        }

        var honorRollSetDependentVisibility = function (combobox)
        {
            var comboboxVar = $(combobox);
            var inclusionType = skyward.controls.getValue(comboboxVar);
            var allowExceptions = skyward.controls.getValue(comboboxVar.parent().find('input.honorRollAllowExceptionCheckbox'));

            if (inclusionType == 'I')
            {
                comboboxVar.parent().find('.fieldWrapper.fsAllowExceptionClassname').show();
                if (allowExceptions)
                {
                    comboboxVar.parent().find('.fieldWrapper.fsGradeMarkExceptionsClassname').show();
                }
            }
            else
            {
                comboboxVar.parent().find('.fieldWrapper.fsAllowExceptionClassname').hide();
                comboboxVar.parent().find('.fieldWrapper.fsGradeMarkExceptionsClassname').hide();
            }
        }

        var rankSetGPACalculationMethodForNewRun = function(radioButton)
        {
            var value = skyward.controls.getValue($(radioButton));
            var gpaCalculationControl = $("#CurrentCalculation")
            var gpaCalculationValue = skyward.controls.getValue(gpaCalculationControl);
            if (value == "N" && gpaCalculationValue == "P")
            {
                skyward.controls.setValue(gpaCalculationControl, "M");
            }
        }

        var honorRollSetGPACalculationMethodForNewRun = function(radioButton)
        {
            var value = skyward.controls.getValue($(radioButton));
            var gpaCalculationControl = $("#CalculationCode")
            var gpaCalculationValue = skyward.controls.getValue(gpaCalculationControl);
            if (value == "N" && gpaCalculationValue == "P")
            {
                skyward.controls.setValue(gpaCalculationControl, "O");
            }
        }

        var generateStudentSectionLinkFormatSample = function (formatBox, radioButton, courseType, transcriptArea)
        {
            var value = skyward.controls.getValue(radioButton);

            var formatString = "School Year, ";
            switch (value)
            {
                case "S":
                    formatString += "Service (District Level)";
                    break;
                case "CU":
                    formatString += "Curriculum (District Level)";
                    break;
                case "CO":
                    formatString += "Course (Entity Level)";
                    break;
            }

            if (courseType.is(":checked"))
            {
                formatString += ", Course Type";
            }

            if (transcriptArea.is(":checked")) {
                formatString += ", Transcript Area";
            }

            skyward.controls.setValue(formatBox, formatString);
        };

        skyward.grading.setCourseGPAMethodGradeReferenceOverride = function (useOverrideCheckbox, checkboxID)
        {
            var useOverrideCheckboxID = 'GradeReferenceOverrideUseOverride-' + checkboxID;
            skyward.grading.courseoverridevaluefunction('GPACredits-' + checkboxID, useOverrideCheckboxID);
            skyward.grading.setoverridepointsetentity('PointSetEntityID-' + checkboxID, useOverrideCheckboxID);
        };

        skyward.grading.setCourseEarnedCreditsMethodGradeReferenceOverride = function (useOverrideCheckbox, checkboxID)
        {
            var useOverrideCheckboxID = 'GradeReferenceOverrideUseOverride-' + checkboxID;
            skyward.grading.courseoverridevaluefunction('EarnedCredits-' + checkboxID, useOverrideCheckboxID);
        };

        skyward.grading.setGradeBucketFlagDetailGPAMethodUseOverride = function (useOverrideCheckbox, checkboxID)
        {
            var useOverrideCheckboxID = 'UseOverride-' + checkboxID;
            var checkbox = $('#' + useOverrideCheckboxID);
            var control = $('#' + 'GPAPoints-' + checkboxID);
            if (checkbox.length == 0)
            {
                return;
            }

            var useOverride = checkbox.is(':checked');

            if (control.length > 0)
            {
                if (useOverride == true)
                {
                    var originalValue = skyward.controls.getOriginalValue(control);
                    if (originalValue != '')
                    {
                        skyward.controls.setValue(control, originalValue);
                    }
                    else
                    {
                        skyward.controls.setValue(control, '0.00000');
                    }
                }
                else
                {
                    skyward.controls.setValue(control, '');
                }
            }
        };

        skyward.grading.setoverridepointsetentity = function (codeeelID, checkboxID)
        {
            var useOverrideCheckbox = $('#' + checkboxID);
            var overridePointSetEntity = $('#' + codeeelID);
            if (useOverrideCheckbox && useOverrideCheckbox.is(':checked'))
            {
                if (skyward.controls.getValue(overridePointSetEntity) == '')
                {
                    var pointSetEntityValue = skyward.controls.getValue($('#editCourseGPAMethod_PointSetEntityID_value'));

                    skyward.controls.setValue(overridePointSetEntity, pointSetEntityValue);
                }
            }
            else
            {
                skyward.controls.setValue(overridePointSetEntity, '');
            }
        };

        skyward.grading.courseoverridevaluefunction = function (controlID, id) {
            var checkbox = $('#' + id);
            var control = $('#' + controlID);
            if (checkbox.length == 0) {
                return;
            }

            var useOverride = checkbox.is(':checked');

            if (control.length > 0) {
                if (useOverride == true) {
                    var originalValue = skyward.controls.getOriginalValue(control);
                    if (originalValue != '')
                    {
                        skyward.controls.setValue(control, originalValue);
                    }
                    else
                    {
                        skyward.controls.setValue(control, '0.000');
                    }
                }
                else
                {
                    skyward.controls.setValue(control, '');
                }
            }
        };

        skyward.grading.honorRollMethodDefaultValueFunction = function (element)
        {
            var checkboxId = element.attr('id');
            if (skyward.controls.getValue(element) == true)
            {
                var idParts = checkboxId.split('-');
                var hidden = $('#editHonorRollMethod_gpaHighDefaultValue');

                var gpaLow = $('#GPALow-add-' + idParts[2]);
                if (skyward.controls.getValue(gpaLow) == '')
                {
                    skyward.controls.setValue(gpaLow, 0);
                }

                var gpaHigh = $('#GPAHigh-add-' + idParts[2]);
                if (skyward.controls.getValue(gpaHigh) == '')
                {
                    skyward.controls.setValue(gpaHigh, skyward.controls.getValue(hidden));
                }
            }
        };

        skyward.grading.retainChanged = function (checkbox)
        {
            var retainTextBox = $('.retainTextBox');
            var days = skyward.controls.getValue(retainTextBox);
            var checked = skyward.controls.getValue(checkbox);
            if (days == '') {
                days = skyward.controls.getOriginalValue(retainTextBox);
            }

            if (!checked) {
                retainTextBox.attr('readonly', 'readonly');
                skyward.controls.setValue(retainTextBox, null);
            }
            else {
                retainTextBox.removeAttr('readonly');
                skyward.controls.setValue(retainTextBox, days);
            }
        };

        skyward.grading.UseEarnedOverrideSetReadOnly = function () {
            var useEarnedOverride = $(this);
            var isUseEarnedOverrideValue = $(this).is(':checked');
            var isUseEarnedOverrideDisabled = $(this).is(':disabled,.ui-disabled');
            var gradeBucketFlagDetailID = useEarnedOverride.attr("id").split("-")[1];
            var useInEarned = $("#editGradeBucketFlagDetails_UseInEarned-" + gradeBucketFlagDetailID);
            var useInEarnedValue = useInEarned.is(':checked');
            var useInFailed = $("#editGradeBucketFlagDetails_UseInFailed-" + gradeBucketFlagDetailID);
            var useInFailedValue = useInFailed.is(':checked');

            if (!isUseEarnedOverrideDisabled)
            {
                if (!isUseEarnedOverrideValue)
                {
                    if (useInEarnedValue)
                    {
                        skyward.controls.setValue(useInEarned, false);
                    }
                    else if (useInFailedValue)
                    {
                        skyward.controls.setValue(useInFailed, false);
                    }

                    skyward.controls.disable(useInFailed);
                    skyward.controls.disable(useInEarned);
                }
                else
                {
                    if (useInEarnedValue)
                    {
                        skyward.controls.disable(useInFailed);
                    }
                    else if (useInFailedValue)
                    {
                        skyward.controls.disable(useInEarned);
                    }
                    else
                    {
                        skyward.controls.enable(useInEarned);
                        skyward.controls.enable(useInFailed);
                    }
                }
            }
        };

        skyward.grading.redirectToLockedByGradebookInformationPopup = function ()
        {
            var button = $(this);
            var buttonData = button.data();
            var entityID = buttonData.entityid;
            var schoolYearID = buttonData.schoolyearid;
            var entityIDHash = buttonData.entityIdHash;
            var schoolYearIDHash = buttonData.schoolyearIdHash;

            var accessMode = $('#accessmode').val();

            var buildPopup = function () {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentGradeBucket/GetLockedByGradebookInformationPopup" + accessMode,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        entityID: entityID,
                        schoolYearID: schoolYearID,
                        entityIDHash: entityIDHash,
                        schoolYearIDHash: schoolYearIDHash
                    }
                });
            };

            var options =
            {
                anchorTo: button
            };
            skyward.modalLayer.showDialog("Grade Information", buildPopup, { text: "Ok", icon: "Check" }, options);

            event.stopPropagation();
        };

        var displayStudentGradeBucketStatusLegend = function () {
            var button = $(this);

            var buildPopup = function () {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentGradeBucket/GetStudentGradeBucketStatusLegend/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { }
                });
            };

            var beforeClose = function () {
                button.off().on('click', displayStudentGradeBucketStatusLegend);
            };

            button.off('click', displayStudentGradeBucketStatusLegend);

            skyward.modalLayer.showDialog("Grade Bucket Status Legend", buildPopup, { text: "Close", icon: "Close" }, { anchorTo: button, beforeClose: beforeClose });
        };

        var displayStudentGradeBucketStatusPopup = function ()
        {
            var button = $(this);
            var StudentGradeBucketID = button.data().id;

            var buildPopup = function () {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentGradeBucket/GetStudentGradeBucketStatusPopup/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { StudentGradeBucketID: JSON.stringify(StudentGradeBucketID) }
                });
            };

            skyward.modalLayer.showDialog("Grade Bucket Status", buildPopup, { text: "Close", icon: "Close" }, { anchorTo: button });
        };

        var displayStudentSectionTypePopup = function ()
        {
            var button = $(this);
            var studentSectionType = button.data().type;

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/GetStudentSectionTypePopup/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { StudentSectionType: studentSectionType }
                });
            };

            skyward.modalLayer.showDialog("Student Section Type", buildPopup, { text: "Close", icon: "Close" }, { anchorTo: button });
        };

        var getTransferAlternativeAjaxSuffix = function (element)
        {
            var studentSectionTypeOverrideElement = element.parents('.skywardContentPanel').find('#StudentSectionTypeOverrideCode');
            var studentSectionTypeOverrideCode = skyward.controls.getValue(studentSectionTypeOverrideElement);
            var suffix = "";

            if (studentSectionTypeOverrideCode === 'A')
            {
                suffix = "Alt";
            }

            return suffix;
        };

        skyward.grading.transferCourseEarnedCreditsPopup = function ()
        {
            var element = $(this);
            var transferCourseID = element.data('transfercourseid');
            var courseEarnedCreditsMethodID = element.data('courseearnedcreditsmethodid');
            var transferCourseData = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
            var suffix = getTransferAlternativeAjaxSuffix(element);

            var saveSettings = function ()
            {
                transferCourseData = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
                var button = $(this);
                var parentWrapper = button.parents('.skywardContentPanel').find('.transferCourseEarnedCreditPopup');
                var useCourseCreditOverride = skyward.controls.getValue(parentWrapper.find('#TransferCourseCreditOverride'));
                var courseCredits = 0;
                if (useCourseCreditOverride === true)
                {
                    courseCredits = skyward.controls.getValue(parentWrapper.find('#TransferCourseEarnedCreditsTextBox'));
                }
                var usePercentOverride = skyward.controls.getValue(parentWrapper.find('#CourseEarnedPercentOverride'));
                var percentOverrides = new Array();
                if (usePercentOverride === true)
                {
                    parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
                    {
                        var textBox = $(this);
                        var value = skyward.controls.getValue(textBox);
                        var gradeBucketID = textBox.data('gradebucketid');
                        var overrideObject = { gradebucketid: gradeBucketID, value: value };
                        percentOverrides.push(overrideObject);
                    });
                }

                $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/SaveTransferCourseEarnedCreditPopup" + suffix,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        transferCourseID: transferCourseID,
                        useCourseCreditOverride: useCourseCreditOverride,
                        courseCredits: courseCredits,
                        usePercentOverride: usePercentOverride,
                        percentOverrides : JSON.stringify(percentOverrides),
                        transferCourseData: transferCourseData,
                        courseEarnedCreditsMethodID: courseEarnedCreditsMethodID
                    },
                    success: function (data)
                    {
                        if (data.ValidPercents === false)
                        {
                            setTransferCoursePercentErrors(parentWrapper);
                        }
                        else
                        {
                            skyward.controls.setValue("#TransferCourseData-" + transferCourseID, data.Update);
                            updateTransferCourseWindowCreditEarningBuckets(JSON.parse(data.Update));
                            //calcTransferCoursesGrandTotals(button);
                            skyward.window.closePopup();
                        }
                    }
                });
            };

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/GetTransferCourseEarnedCreditsPopup" + suffix,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        transferCourseID: transferCourseID,
                        transferCourseData: transferCourseData,
                        courseEarnedCreditsMethodID: courseEarnedCreditsMethodID
                    }
                });
            };

            var options =
            {
                draggable: true,
                closeOnClick: false,
                closeOnEscape: false
            };

            var htmlResponse = buildPopup();
            htmlResponse.done(function (html)
            {
                skyward.modalLayer.showDialog("Earned Credits", html, [{ id: 'btnSettingsSave', text: 'Done', icon: 'Check', click: saveSettings }, { text: 'Cancel', icon: 'Cancel', click: 'close' }], options);
            });
        };

        skyward.grading.transferCourseGPAPopup = function ()
        {
            var element = $(this);
            var transferCourseID = element.data('transfercourseid');

            var transferCourseData = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
            var courseGPAMethodID = element.data('coursegpamethodid');
            var suffix = getTransferAlternativeAjaxSuffix(element);

            var saveSettings = function ()
            {
                transferCourseData = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
                var button = $(this);
                var parentWrapper = button.parents('.skywardContentPanel').find('.transferCourseGPAPopup');
                var useCourseCreditOverride = skyward.controls.getValue(parentWrapper.find('#PointSetAndCreditOverride'));
                var courseCredits = 0;
                var pointSetID = null;
                if (useCourseCreditOverride === true)
                {
                    courseCredits = skyward.controls.getValue(parentWrapper.find('#TransferCourseGPAPopupPossibleCreditBox'));
                    pointSetID = skyward.controls.getValue(parentWrapper.find('#TransferCourseGPAPopupPointSetID'));
                }
                var usePercentOverride = skyward.controls.getValue(parentWrapper.find('#CourseGPAPercentOverride'));
                var percentOverrides = new Array();
                if (usePercentOverride === true)
                {
                    parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
                    {
                        var textBox = $(this);
                        var value = skyward.controls.getValue(textBox);
                        var gradeBucketID = textBox.data('gradebucketid');
                        var overrideObject = { gradebucketid: gradeBucketID, value: value };
                        percentOverrides.push(overrideObject);
                    });
                }

                $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/SaveTransferCourseGPACreditPopup" + suffix,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        transferCourseID: transferCourseID,
                        useCourseCreditOverride: useCourseCreditOverride,
                        courseCredits: courseCredits,
                        pointSetID: pointSetID,
                        usePercentOverride: usePercentOverride,
                        percentOverrides: JSON.stringify(percentOverrides),
                        transferCourseData: transferCourseData,
                        courseGPAMethodID: courseGPAMethodID
                    },
                    success: function (data)
                    {
                        if (data.ValidPercents === false)
                        {
                            setTransferCoursePercentErrors(parentWrapper);
                        }
                        else
                        {
                            skyward.controls.setValue("#TransferCourseData-" + transferCourseID, data.Update);
                            updateTransferCourseWindowCreditEarningBuckets(JSON.parse(data.Update));
                            skyward.window.closePopup();
                        }
                    }
                });
            };

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/GetTransferCourseGPAPopup" + suffix,
                    type: "POST",
                    dataType: "viewpartHtml",
                    data:
                    {
                        transferCourseID: transferCourseID,
                        transferCourseData: transferCourseData,
                        courseGPAMethodID: courseGPAMethodID
                    }
                });
            };

            var options =
            {
                draggable: true,
                closeOnClick: false,
                closeOnEscape: false
            };

            var htmlResponse = buildPopup();
            htmlResponse.done(function (html)
            {
                skyward.modalLayer.showDialog("GPA Totals", html, [{ id: 'btnSettingsSave', text: 'Done', icon: 'Check', click: saveSettings }, { text: 'Cancel', icon: 'Cancel', click: 'close' }], options);
            });
        };

        var setTransferCoursePercentErrors = function (parentWrapper)
        {
            var errorData = { errors: {} };
            var popUpErrors = parentWrapper.find('#popUpErrors');
            parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
            {
                var item = $(this);
                errorData.errors[item.data("validate-control-for")] = ["Total Percent must equal 0 or 100."];
            });
            skyward.validation.displayValidationMessages(errorData, parentWrapper, popUpErrors, null, null);
        };

        var updateTransferCourseGradeBucketFlagData = function ()
        {
            var element = $(this);
            var cleanID = element.attr('id').split('_')[0];
            var idParts = cleanID.split('-');
            var transferCourseID = idParts[1];
            var gradeBucketID = idParts[2];

            var dataElement = $('#TransferCourseData-' + transferCourseID);
            var transferCourseData = skyward.controls.getValue(dataElement);
            var data = JSON.parse(skyward.controls.getValue(dataElement));
            var backingData = skyward.controls.getValue(element.find('.dmsBackingData'));
            var suffix = getTransferAlternativeAjaxSuffix(element);

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/SetTransferCourseGradeBucketFlags" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseID: transferCourseID,
                    gradeBucketID: gradeBucketID,
                    transferCourseData: transferCourseData,
                    gradeBucketFlags: JSON.stringify(backingData)
                },
                success: function (returnData)
                {
                    skyward.controls.setValue("#TransferCourseData-" + transferCourseID, returnData.Update);
                    setEarnedCreditColumn(returnData, transferCourseID, data.EntityID, data.SchoolYearID);
                    setGPAColumn(returnData, transferCourseID, data.EntityID, data.SchoolYearID);
                }
            });
        }

        var updateTransferCourseGradeMarkData = function ()
        {
            var element = $(this);
            var cleanID = element.attr('id').split('_')[0];
            var idParts = cleanID.split('-');
            var transferCourseID = idParts[1];
            var gradeBucketID = idParts[2];

            var dataElement = $('#TransferCourseData-' + transferCourseID);
            var transferCourseData = skyward.controls.getValue(dataElement);
            var data = JSON.parse(skyward.controls.getValue(dataElement));
            var gradeMarkID = skyward.controls.getValue(element);
            var suffix = getTransferAlternativeAjaxSuffix(element);

            skyward.controls.setValue(dataElement, JSON.stringify(data));

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/SetTransferCourseGradeMarks" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseID: transferCourseID,
                    gradeBucketID: gradeBucketID,
                    transferCourseData: transferCourseData,
                    gradeMarkID: gradeMarkID
                },
                success: function (returnData)
                {
                    skyward.controls.setValue("#TransferCourseData-" + transferCourseID, returnData.Update);
                    setEarnedCreditColumn(returnData, transferCourseID, data.EntityID, data.SchoolYearID);
                    setGPAColumn(returnData, transferCourseID, data.EntityID, data.SchoolYearID);
                }
            });
        }

        var updateTransferCourseCompletionDate = function () {
            var element = $(this);
            var cleanID = element.attr('id').split('_')[0];
            var idParts = cleanID.split('-');
            var transferCourseID = idParts[1];
            var gradeBucketID = idParts[2];

            var dataElement = $('#TransferCourseData-' + transferCourseID);
            var transferCourseData = skyward.controls.getValue(dataElement);
            var data = JSON.parse(transferCourseData);
            var suffix = getTransferAlternativeAjaxSuffix(element);

            var overrideCompletionDate = skyward.controls.getValue($("#creditEarningDateOverride-" + transferCourseID + "-" + gradeBucketID));
            const completionDateElement = $("#creditEarningDate-" + transferCourseID + "-" + gradeBucketID);
            const completionDate = skyward.time.formatServerDate(skyward.controls.getValue(completionDateElement), false);

            skyward.controls.setValue(dataElement, JSON.stringify(data));

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/SetTransferCourseCompletionDates" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseID: transferCourseID,
                    gradeBucketID: gradeBucketID,
                    transferCourseData: transferCourseData,
                    overrideCompletionDate: overrideCompletionDate,
                    completionDate: completionDate
                },
                success: function (returnData) {
                    skyward.controls.setValue("#TransferCourseData-" + transferCourseID, returnData.Update);
                }
            });
        }

        var setEarnedCreditColumn = function (data, transferCourseID, entityID, schoolYearID)
        {
            var parseData = JSON.parse(data.Update);
            for (var i = 0; i < parseData.TransferCourseEarnedCreditsMethods.length; i++)
            {
                var courseEarnedCreditsMethod = parseData.TransferCourseEarnedCreditsMethods[i];
                $("#EarnedCreditsLink-" + transferCourseID + "-" + courseEarnedCreditsMethod.CourseEarnedCreditsMethodID).find('span').html(formatCredits(courseEarnedCreditsMethod.TotalEarnedCredits));
                $("#FailedCreditsLink-" + transferCourseID + "-" + courseEarnedCreditsMethod.CourseEarnedCreditsMethodID).find('span').html(formatCredits(courseEarnedCreditsMethod.TotalFailedCredits));
            }


            //$("#EarnedCreditLink-" + transferCourseID).find('span').html(formatCredits(earnedCredits));
            //$("#FailedCreditLink-" + transferCourseID).find('span').html(formatCredits(failedCredits));

            //var totalEarned = 0;
            //var totalFailed = 0;

            //var groupWrapper = buttonElement.parents('#creditEarningGroupRowWapper-' + entityID + '-' + schoolYearID);

            //groupWrapper.find("a[id^='EarnedCreditLink']").each(function ()
            //{
            //    var link = $(this);
            //    var value = parseFloat(link.find('span').html());
            //    totalEarned += value
            //});

            //groupWrapper.find("a[id^='FailedCreditLink']").each(function ()
            //{
            //    var link = $(this);
            //    var value = parseFloat(link.find('span').html());
            //    totalFailed += value
            //});

            //$("#GroupEarnedCreditTotal-" + entityID + "-" + schoolYearID).html(formatCredits(totalEarned));
            //$("#GroupFailedCreditTotal-" + entityID + "-" + schoolYearID).html(formatCredits(totalFailed));
            //calcTransferCoursesGrandTotals(buttonElement);
        }

        var setGPAColumn = function (data, transferCourseID, entityID, schoolYearID)
        {
            var parseData = JSON.parse(data.Update);
            for (var i = 0; i < parseData.TransferCourseGPAMethods.length; i++)
            {
                var courseGPAMethod = parseData.TransferCourseGPAMethods[i];
                $("#GPACreditLink-" + transferCourseID + "-" + courseGPAMethod.CourseGPAMethodID).find('span').html(formatCredits(courseGPAMethod.TotalCredits));
                $("#GPAPointsLink-" + transferCourseID + "-" + courseGPAMethod.CourseGPAMethodID).find('span').html(formatCredits(courseGPAMethod.TotalPoints));
                $("#GPAAddOnPointsLink-" + transferCourseID + "-" + courseGPAMethod.CourseGPAMethodID).find('span').html(formatCredits(courseGPAMethod.TotalAddOnPoints));
            }
        }

        var formatCredits = function (value)
        {
            var decimalMask = "9999.99";
            var masks = decimalMask.toString().split('.');
            var precision = masks.length > 1 ? masks[1].length : 0;

            var valueParts = value.toString().split('.');
            value = valueParts[0];
            if (precision > 0)
            {
                var afterDecimal = valueParts.length > 1 ? valueParts[1] : '';
                value += '.' + afterDecimal;
                for (var i = 0, len = precision - afterDecimal.length; i < len; i++)
                {
                    value += '0';
                }
            }
            return value;
        }

        var resetTransferCourseCreditOverride = function ()
        {
            var element = $(this);
            var overrideValue = skyward.controls.getValue(element);
            if (overrideValue === false)
            {
                var parentWrapper = element.parents('.transferCourseEarnedCreditPopup');

                var creditBox = parentWrapper.find('#TransferCourseEarnedCreditsTextBox');
                var baseValue = creditBox.data('basevalue');

                skyward.controls.setValue(creditBox, baseValue);
            }
        }

        var resetTransferCourseGPACreditOverride = function ()
        {
            var element = $(this);
            var overrideValue = skyward.controls.getValue(element);
            if (overrideValue === false)
            {
                var parentWrapper = element.parents('.transferCourseGPAPopup');

                var pointSet = parentWrapper.find('#TransferCourseGPAPopupPointSetID');
                var baseValue = pointSet.data('basevalue');
                skyward.controls.setValue(pointSet, baseValue);

                var gpaCredits = parentWrapper.find('#TransferCourseGPAPopupPossibleCreditBox');
                var baseValue = gpaCredits.data('basevalue');
                skyward.controls.setValue(gpaCredits, baseValue);
            }
        }

        var resetTransferCoursePercentOverride = function ()
        {
            var element = $(this);
            var overrideValue = skyward.controls.getValue(element);
            if (overrideValue === false)
            {
                var parentWrapper = element.parents('.transferCourseEarnedCreditPopup');
                var percentBoxes = parentWrapper.find('.TransferCoursePercentOverrideBox');
                percentBoxes.each(function ()
                {
                    var textBox = $(this);
                    var baseValue = textBox.data('basevalue');
                    skyward.controls.setValue(textBox, baseValue, true);
                });
                updateEarnedCreditPopupCalculation.call(element);
            }
        }

        var resetTransferCourseGPAPercentOverride = function ()
        {
            var element = $(this);
            var overrideValue = skyward.controls.getValue(element);
            if (overrideValue === false)
            {
                var parentWrapper = element.parents('.transferCourseGPAPopup');
                var percentBoxes = parentWrapper.find('.TransferCoursePercentOverrideBox');
                percentBoxes.each(function ()
                {
                    var textBox = $(this);
                    var baseValue = textBox.data('basevalue');
                    skyward.controls.setValue(textBox, baseValue);
                });
            }
        }

        var updateEarnedCreditPopupCalculation = function ()
        {
            var element = $(this);
            var parentWrapper = element.parents(".transferCourseEarnedCreditPopup");
            var transferCourseID = parentWrapper.data("transfercourseid");
            var courseEarnedCreditsMethodID = parentWrapper.data("courseearnedcreditsmethodid");
            var suffix = getTransferAlternativeAjaxSuffix(element);

            var transferCourseData = skyward.controls.getValue(parentWrapper.find(".transferCourseData"));
            var credits = skyward.controls.getValue(parentWrapper.find('#TransferCourseEarnedCreditsTextBox'));
            var creditOverride = skyward.controls.getValue(parentWrapper.find('#TransferCourseCreditOverride'));
            var percentOverride = skyward.controls.getValue(parentWrapper.find('#CourseEarnedPercentOverride'));
            var percents = {};
            parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
            {
                var percentBox = $(this);
                var gradeBucketID = percentBox.data('gradebucketid');
                var percent = skyward.controls.getValue(percentBox);
                if (percent == null || percent == undefined)
                {
                    percent == 0;
                }
                percents[gradeBucketID] = percent;
            });

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/TransferCourseEarnedCreditPopupRecalc" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseData: transferCourseData,
                    transferCourseID: transferCourseID,
                    credits: credits,
                    creditOverride: creditOverride,
                    percentOverride: percentOverride,
                    percents: JSON.stringify(percents),
                    courseEarnedCreditsMethodID: courseEarnedCreditsMethodID
                },
                success: async function (returnData)
                {
                    var updateHTML = returnData.Success;
                    if (updateHTML === true)
                    {
                        await parentWrapper.find('#creditWrapper').viewpartHtml(returnData.CreditsHTML);
                        skyward.window.notifyResize();
                    }
                }
            });
        }

        var updateGPACreditPopupCalculation = function ()
        {
            var element = $(this);
            var parentWrapper = element.parents(".transferCourseGPAPopup");
            var transferCourseID = parentWrapper.data("transfercourseid");
            var courseGPAMethodID = parentWrapper.data("coursegpamethodid");
            var suffix = getTransferAlternativeAjaxSuffix(element);

            var transferCourseData = skyward.controls.getValue("#TransferCourseData-" + transferCourseID);
            var credits = skyward.controls.getValue(parentWrapper.find('#TransferCourseGPAPopupPossibleCreditBox'));
            var pointSetID = skyward.controls.getValue(parentWrapper.find('#TransferCourseGPAPopupPointSetID'));
            var creditOverride = skyward.controls.getValue(parentWrapper.find('#PointSetAndCreditOverride'));
            var percentOverride = skyward.controls.getValue(parentWrapper.find('#CourseGPAPercentOverride'));
            var percents = {};
            parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
            {
                var percentBox = $(this);
                var gradeBucketID = percentBox.data('gradebucketid');
                var percent = skyward.controls.getValue(percentBox);
                if (percent == null || percent == undefined)
                {
                    percent == 0;
                }
                percents[gradeBucketID] = percent;
            });

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/TransferCourseGPACreditPopupRecalc" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseData: transferCourseData,
                    transferCourseID: transferCourseID,
                    credits: credits,
                    creditOverride: creditOverride,
                    pointSetID: pointSetID,
                    percentOverride: percentOverride,
                    percents: JSON.stringify(percents),
                    courseGPAMethodID: courseGPAMethodID
                },
                success: async function (returnData)
                {
                    skyward.controls.setValue("#TransferCourseData-" + transferCourseID, returnData.Update);
                    var updateHTML = returnData.Success;
                    if (updateHTML === true)
                    {
                        await parentWrapper.find('#creditWrapper').viewpartHtml(returnData.CreditsHTML);
                        skyward.window.notifyResize();
                    }
                }
            });
        }

        var updateTransferCourseWindowCreditEarningBuckets = function (updateData)
        {
            var transferCourseWrapper = $('.transferCourseGradeWrapper');
            var creditEarningGroup = transferCourseWrapper.find('#creditEarningGroupRowWapper-' + updateData.EntityID + '-' + updateData.SchoolYearID);
            var earnedCreditsGroup = transferCourseWrapper.find('#earnedCreditsGroupWrapper-' + updateData.EntityID + '-' + updateData.SchoolYearID);
            var gpaGroup = transferCourseWrapper.find('#gPAGroupWapper-' + updateData.EntityID + '-' + updateData.SchoolYearID);
            var nonEarningGroup = transferCourseWrapper.find('#nonEarningGroupWapper-' + updateData.EntityID + '-' + updateData.SchoolYearID);
            regenerateTransferCourseScreen(creditEarningGroup, earnedCreditsGroup, gpaGroup, nonEarningGroup);
        };

        var regenerateTransferCourseScreen = function (creditEarningWrapper, earnedCreditsWrapper, gpaGroup, nonEarningGroup)
        {
            var transferCourses = {};
            //get transfercourses in this group
            earnedCreditsWrapper.find('[id^=earnedCreditsTransferCourseID]').each(function ()
            {
                var transferCourseID = $(this).attr('id').split('-')[1];
                transferCourses[transferCourseID] = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
            });
            var suffix = getTransferAlternativeAjaxSuffix(earnedCreditsWrapper);

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/TransferCourseRegenerateGradingScreen" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseDatas: JSON.stringify(transferCourses)
                },
                success: async function (returnData)
                {
                    const [creditEarningGroupHTML, earnedCreditsGroupHTML, gPAGroupHTML, nonEarningGroupHTML] = await Promise.all([
                        skyward.global.processViewPartHtml(returnData.CreditEarningGroupHTML),
                        skyward.global.processViewPartHtml(returnData.EarnedCreditsGroupHTML),
                        skyward.global.processViewPartHtml(returnData.GPAGroupHTML),
                        skyward.global.processViewPartHtml(returnData.NonEarningGroupHTML),
                    ])

                    creditEarningWrapper.html(creditEarningGroupHTML);

                    $(creditEarningWrapper).find('.codeEEL').each(function ()
                    {
                        skyward.codeeel.registerCodeEEL($(this));
                    });
                    $(creditEarningWrapper).find('.distinctMultiSelectEEL').each(function ()
                    {
                        skyward.distinctMultiSelectEEL.registerDistinctMultiSelectEEL($(this))
                    });

                    $(creditEarningWrapper).find('.transferCourseUpdatesGradeMarkInformation').parent().off('codeEELValuesUpdated', updateTransferCourseGradeMarkData).on('codeEELValuesUpdated', updateTransferCourseGradeMarkData);
                    $(creditEarningWrapper).find('.TransferCourseGradeBucketFlag').parent().off('change', updateTransferCourseGradeBucketFlagData).on('change', updateTransferCourseGradeBucketFlagData);

                    earnedCreditsWrapper.html(earnedCreditsGroupHTML);
                    gpaGroup.html(gPAGroupHTML);
                    nonEarningGroup.html(nonEarningGroupHTML);

                    $(nonEarningGroup).find('.codeEEL').each(function ()
                    {
                        skyward.codeeel.registerCodeEEL($(this));
                    });
                    $(nonEarningGroup).find('.distinctMultiSelectEEL').each(function ()
                    {
                        skyward.distinctMultiSelectEEL.registerDistinctMultiSelectEEL($(this))
                    });
                    $(nonEarningGroup).find('.transferCourseUpdatesGradeMarkInformation').parent().off('codeEELValuesUpdated', updateTransferCourseGradeMarkData).on('codeEELValuesUpdated', updateTransferCourseGradeMarkData);
                    $(nonEarningGroup).find('.TransferCourseGradeBucketFlag').parent().off('change', updateTransferCourseGradeBucketFlagData).on('change', updateTransferCourseGradeBucketFlagData);
                    //calcTransferCoursesGrandTotals(creditEarningWrapper);
                }
            });
        }

        //var calcTransferCoursesGrandTotals = function (element)
        //{
        //    var parent = element.parents('.transferCourseGradeWrapper')
        //    var creditEarning = parent.find('.creditEarningGroup');
        //    var earnedCredits = creditEarning.find('[id^="GroupEarnedCreditTotal"]');
        //    var failedCredits = creditEarning.find('[id^="GroupFailedCreditTotal"]');
        //    var earnedTotal = 0;
        //    var failedTotal = 0;

        //    earnedCredits.each(function ()
        //    {
        //        var credit = $(this);
        //        earnedTotal += parseFloat(credit.html());
        //    });
        //    failedCredits.each(function ()
        //    {
        //        var credit = $(this);
        //        failedTotal += parseFloat(credit.html());
        //    });

        //    parent.find('#EarnedGrandTotal').html(formatCredits(earnedTotal));
        //    parent.find('#FailedGrandTotal').html(formatCredits(failedTotal));
        //}

        var makeOutOfDistrictTransferCoursePopup = function ()
        {
            var button = $(this);

            var options =
            {
                draggable: true,
                closeOnClick: false,
                closeOnEscape: false,
                additionalClasses: 'warningPopupDialog'
            };

            var saveSettings = function()
            {
                var data =
                {
                    "Workflow.StudentSectionID": button.data('studentsectionid'),
                    "Workflow.StudentSectionID_securityhash": button.data('studentsectionidhash')
                };
                skyward.window.checkLoadContent("popup", "Workflow", "WorkflowInstance", "Create/Grading/StudentSection/ChangeSectionToOutOfDistrictTransferCourse", null, data);
            };

            var studentName = button.data('studentname');
            var html = "<div class = 'warningPopupDialogTitle'><span>Are You Sure?</span></div><div class = 'warningPopupDialogMessage'><span>";
            var iconspan = $('<span/>');
            $.when(skyward.svg.getSvg('Warning', 'Warning')).done(function (svg)
            {
                iconspan.append(svg);
            });
            html += iconspan.html();
            html += "Changing " + studentName + "'s section to an out of district transfer course will remove them from the teacher's gradebook. This will also set all grade buckets to complete which could affect GPA and Earned Credits.</span></div>"
            skyward.modalLayer.showDialog("", html, [{ id: 'btnGoBack', icon: null, text: 'No, Go Back', additionalClasses: "warningPopupDialogNo", click: 'close' }, { id: 'btnYes', icon: null, text: 'Yes, Change Section', additionalClasses: "warningPopupDialogYes", click: saveSettings }], options);
        }

        var rebuildFileNameOutput = function (fileNameFormatContainer)
        {
            var childRecordGenerator = fileNameFormatContainer.find(".fileNameFormatQuickEntry");
            var fileNameFormatDelimiterType = fileNameFormatContainer.find(".fileNameFormatDelimiterType").first();
            var outputTextbox = fileNameFormatContainer.find(".fileNameFormatOutput");
            var currentOutputText = skyward.controls.getValue(outputTextbox);
            var delimiter = getFileTypeDelimiterValue(fileNameFormatDelimiterType);
            var currentOutputTextParts = delimiter != null && delimiter != "" ? currentOutputText.split(delimiter) : [currentOutputText];
            var outputText = "";
            var count = 0;
            childRecordGenerator.find(".fileNameFormatEntryOption").each(function ()
            {
                var option = $(this);
                var row = option.parents("tr");

                var processOption = row == null || row.length == 0 || !row.hasClass("skip");
                if (processOption)
                {
                    var optionValue;
                    if (option.hasClass("useComboBoxOptionDisplayText"))
                    {
                        if (option.get(0).selectedIndex > -1)
                        {
                            optionValue = "[" + option.get(0).options[option.get(0).selectedIndex].text + "]";

                            if (optionValue == "[Date]")
                            {
                                const datepicker = option.parents("tr").first().find(".datePickerFieldset sky-datepicker");
                                const datePickerValue = skyward.controls.getValue(datepicker);
                                optionValue = datePickerValue == null || (datePickerValue instanceof Date && !datePickerValue.isValidDate())
                                    ? ""
                                    : datePickerValue.toISOString().split('T')[0];
                            }
                            else if (optionValue == "[Custom Text]")
                            {
                                var customTextHelp = option.parents("tr").first().find(".customTextFieldset input.customText");
                                optionValue = skyward.controls.getValue(customTextHelp);
                            }
                        }
                    }
                    else
                    {
                        optionValue = "[" +skyward.controls.getValue(option) + "]";
                    }

                    if (optionValue)
                    {
                        if (outputText != "")
                        {
                            outputText += getFileTypeDelimiterValue(fileNameFormatDelimiterType);
                        }
                        outputText += optionValue;
                    }
                }

                count++;
            });

            skyward.controls.setValue(outputTextbox, outputText);
        };

        var getFileTypeDelimiterValue = function (fileNameFormatDelimiterType)
        {
            if (fileNameFormatDelimiterType.get(0).selectedIndex > -1)
            {
                var delimterString = fileNameFormatDelimiterType.get(0).options[fileNameFormatDelimiterType.get(0).selectedIndex].text;
                if (delimterString == "Space")
                {
                    delimterString = " ";
                }
                return delimterString;
            }
            return "";
        }

        // Event handlers
        var events =
        {
            "displayStudentGradeBucketStatusPopup": displayStudentGradeBucketStatusPopup,
            "displayStudentSectionTypePopup": displayStudentSectionTypePopup,
            "redirectToLockedByGradebookInformationPopup": skyward.grading.redirectToLockedByGradebookInformationPopup,
            "transferCourseEarnedCreditsPopup": skyward.grading.transferCourseEarnedCreditsPopup,
            "transferCourseGPAPopup": skyward.grading.transferCourseGPAPopup,
            initGradeReportHeaderFields,
            initStudentSectionLinkFormat,
        };
        skyward.events.registerEvents("Grading", events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
